import { PropsWithChildren, useEffect } from "react";
import { sendLog } from "@/utils/tracker";

interface TrackerData {
  topic: string;
  activity: string;
  data: Record<string, unknown>;
}

const TrackerWrapper = ({ children }: PropsWithChildren) => {
  const handleDocumentClick = (e: MouseEvent) => {
    // 处理点击事件
    const target = e.target as HTMLElement;

    // 获取包含 data-tracker 的元素
    const trackerDataString = target.getAttribute("data-tracker");

    if (trackerDataString) {
      try {
        // 解析 JSON 字符串为对象
        const trackerData: TrackerData = JSON.parse(trackerDataString);

        if (trackerData.topic && trackerData.activity) {
          // 发送埋点数据
          console.log("埋点数据:", trackerData);
          sendLog(trackerData.topic, trackerData.activity, trackerData.data);
        } else {
          console.error(
            "埋点数据格式错误: ",
            trackerData,
            "缺少 topic 或 activity 属性",
          );
        }
      } catch (error) {
        console.error("解析埋点数据失败: 需传入JSON字符串", error);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick, false);
    return () => {
      document.removeEventListener("click", handleDocumentClick, false);
    };
  }, []);

  return children;
};

export default TrackerWrapper;
